import React from "react";
import axios from "axios";
import AvatarEditor from "react-avatar-editor";
import { Config } from "../../../../../../Config";
import LoadingIcon from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import WhiteCanvas from "../../../../../../Assets/Images/WhiteSpace.png";

class HeaderImageUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AlreadyHasImage: false,
      IsUploading: false,
      HeaderURL: "",
      ImageIsChanged: false,
      ChangesMade: false,
      HeaderDeleted: false,
      ErrorMessage: undefined,
    };
  }
  componentDidMount() {
    this.checkPrevImage();
  }
  checkPrevImage() {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-background",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.imageUrl.length > 0) {
          this.setState({
            AlreadyHasImage: true,
            HeaderURL: Res.data.imageUrl,
          });
        }
      })
      .catch((Err) => {
        console.log(Err);
        this.setState({
          HeaderURL: this.props.Image,
          ChangesMade: false,
          AlreadyHasImage: false,
        });
      });
  }
  onClickSave = () => {
    if (this.editor) {
      if (this.state.HeaderDeleted) {
        this.requestDeleteHeader();
      } else {
        const canvasScaled = this.editor
          .getImageScaledToCanvas()
          .toDataURL("image/jpeg")
          .split(";base64,")[1];
        if (this.state.AlreadyHasImage === true) {
          this.requestReplaceImage(canvasScaled);
        } else {
          this.requestUploadImage(canvasScaled);
        }
      }
    }
  };
  requestReplaceImage = (Image) => {
    let Data = new FormData();
    this.setState({ IsUploading: true });
    Data.append("type", "BACKGROUND");
    Data.append("file", Image);
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        this.props.Close();
        this.props.FetchImage();
        this.setState({ IsUploading: false });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  requestUploadImage(Image) {
    this.setState({ IsUploading: true });
    let Data = new FormData();
    Data.append("type", "BACKGROUND");
    Data.append("file", Image);
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        this.props.Close();
        this.props.FetchImage();
        this.setState({ IsUploading: false });
      })
      .catch((Err) => {
        console.log(Err.response);
        this.setState({ IsUploading: false });
        if (Err.response.data.key === "validation_error") {
          this.setState({ ErrorMessage: Err.response.data.messages[0] });
        }
      });
  }
  handleChange() {
    this.setState({
      ImageIsChanged: true,
      HeaderDeleted: false,
      ErrorMessage: undefined,
    });
    this.props.ChangeImage();
  }
  handleDeleteImage() {
    this.setState({
      HeaderURL: WhiteCanvas,
      ChangesMade: true,
      HeaderDeleted: true,
      ImageIsChanged: true,
      ErrorMessage: undefined,
    });
    this.props.RemoveImage();
  }
  requestDeleteHeader() {
    let Data = new FormData();
    Data.append("type", "BACKGROUND");
    let Req = {
      method: "DELETE",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        this.props.Close();
        this.props.FetchImage();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.data.key === "not_found_error") {
          this.props.Close();
        }
      });
  }

  handleClose() {
    this.setState(
      {
        AlreadyHasImage: false,
        IsUploading: false,
        HeaderURL: "",
        ImageIsChanged: false,
        ChangesMade: false,
        HeaderDeleted: false,
      },
      () => {
        this.props.Close();
      }
    );
  }

  setEditorRef = (editor) => (this.editor = editor);
  render() {
    return (
      <div className="image-uploader-wrapper-large">
        <div className="header-image-area">
          <section className="image-uploader-head">
            <h1>Background photo</h1>
            <i className="feather-x" onClick={() => this.props.Close()}></i>
          </section>
          <div className="canvas-wrapper">
            {this.state.ImageIsChanged ? (
              <AvatarEditor
                image={
                  this.props.Image === undefined || this.props.Image === ""
                    ? this.state.HeaderURL
                    : this.props.Image
                }
                width={852}
                height={102}
                color={[71, 79, 89, 0.8]} // RGBA
                border={[0, 80]}
                scale={1}
                rotate={0}
                ref={this.setEditorRef}
              />
            ) : (
              <AvatarEditor
                image={this.state.HeaderURL}
                width={852}
                height={102}
                color={[71, 79, 89, 0.8]} // RGBA
                border={[0, 80]}
                scale={1}
                rotate={0}
                ref={this.setEditorRef}
              />
            )}

            <p className="hint-text">Drag to reposition photo</p>
          </div>
          <section className="cropper-options">
            {this.state.ErrorMessage ? (
              <p className="error-text">{this.state.ErrorMessage}</p>
            ) : null}
            <span className="remove" onClick={() => this.handleDeleteImage()}>
              Remove photo
            </span>
            <span className="change" onClick={() => this.handleChange()}>
              Change photo
            </span>
            {this.state.IsUploading ? (
              <span className="apply">
                <img alt="" src={LoadingIcon} />
              </span>
            ) : (
              <React.Fragment>
                {this.state.ChangesMade ? (
                  <React.Fragment>
                    {this.props.Image !== this.state.HeaderURL ? (
                      <span
                        className="apply"
                        id="apply-profile-btn"
                        onClick={() => this.onClickSave()}
                      >
                        Apply
                      </span>
                    ) : (
                      <span className="apply apply-disabled">Apply</span>
                    )}
                  </React.Fragment>
                ) : (
                  <span
                    id="apply-profile-btn"
                    onClick={() => this.onClickSave()}
                    className="apply apply-disabled"
                  >
                    Apply
                  </span>
                )}
              </React.Fragment>
            )}
          </section>
        </div>
      </div>
    );
  }
}
export default HeaderImageUploader;
